export function isEdge() {
    return (getBrowser() === "edge");
}

export function getBrowser(){

    const ua = window.navigator.userAgent.toLowerCase();
    const ver = window.navigator.appVersion.toLowerCase();

    if (ua.indexOf('edge') !== -1) return 'edge';                           // Edge
    else if (ua.indexOf("iemobile") !== -1)      return 'iemobile';         // ieMobile
    else if (ua.indexOf('trident/7') !== -1)     return 'ie11';             // ie11
    else if (ua.indexOf("msie") !== -1 && ua.indexOf('opera') === -1){
        if      (ver.indexOf("msie 6.")  !== -1) return 'ie6';              // ie6
        else if (ver.indexOf("msie 7.")  !== -1) return 'ie7';              // ie7
        else if (ver.indexOf("msie 8.")  !== -1) return 'ie8';              // ie8
        else if (ver.indexOf("msie 9.")  !== -1) return 'ie9';              // ie9
        else if (ver.indexOf("msie 10.") !== -1) return 'ie10';             // ie10
    }
    else if (ua.indexOf('chrome')  !== -1 && ua.indexOf('edge') === -1)   return 'chrome';    // Chrome
    else if (ua.indexOf('safari')  !== -1 && ua.indexOf('chrome') === -1) return 'safari';    // Safari
    else if (ua.indexOf('opera')   !== -1) return 'opera';                  // Opera
    else if (ua.indexOf('firefox') !== -1) return 'firefox';                // FIrefox
    else return 'unknown_browser';
}


// WEBPACK FOOTER //
// ./src/common/utils/brower.js